import { wrapperBuilder } from './build';
import { TRANSPORTS } from './others/transportDefinitions';

wrapperBuilder
  .getStaticsGeneratorsRegisterInstance()
  .addStaticProp('TRANSPORTS', TRANSPORTS);
